import useMutationPostCommentDelete from "./comment-use-mutation-delete";



export const commentUseMutation = {
  delete: useMutationPostCommentDelete,
}